<template>
    <div class="transparency_nav second_font">
        <ul>
            <li
                v-for="type in types"
                :key="type.text"
                :class="{ active: type.value === selectedType.value }"
                @click="selectedType = { ...type }"
            >
                {{ type.text }}
            </li>
        </ul>
    </div>
</template>

<script>
import types from '@/../common/transparency-type';

export default {
    data() {
        const defaultType = { text: 'את כל', value: null };

        return {
            selectedType: { ...defaultType },
            types: [
                defaultType,
                ...types.map(type => ({ text: type, value: type }))
            ]
        };
    },

    watch: {
        selectedType({ value }) {
            this.$emit('selected', value);
        }
    }
};
</script>
